import { queryOptions } from '@tanstack/react-query'

import { knockOutFetcher } from '@/libs/fetcher/presets'

import type { PredictionEventDurationsResponse } from './types'

/**
 * Recurring 事件的周期标签（"5 min" / "2 hour"）—— cdc-web `useEventDurations`
 * 的 RQ 版。匿名访客可访问，必须走 public 前缀 `/predictions/public`
 * （knockOutFetcher；private 代理路径会 401 匿名用户）。
 */
export function predictionEventDurationsQueryOptions(eventKind: string) {
  return queryOptions({
    queryKey: ['prediction', 'event-durations', eventKind] as const,
    queryFn: () =>
      knockOutFetcher<PredictionEventDurationsResponse>(
        '/api/v1/event-durations',
        { queries: { event_kind: eventKind } },
        { successResponseDataProperty: '' },
      ).then(res => res?.data ?? []),
    // 周期表随 event_kind 基本不变，长缓存避免每次渲染重打。
    staleTime: 5 * 60 * 1000,
  })
}
